var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShaolinKungFu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5F7DBE;}\r\n\t.st1{fill:#464646;}\r\n\t.st2{fill:#323232;}\r\n\t.st3{fill:#5055A5;}\r\n\t.st4{fill:#FAA51E;}\r\n\t.st5{fill:#F0915A;}\r\n\t.st6{fill:#FAB991;}\r\n\t.st7{fill:#D7E6F0;}\r\n\t.st8{fill:#AAC3D7;}\r\n\t.st9{fill:#FAD241;}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{fill:#8CAAC8;}\r\n\t.st12{fill:#FFC33C;}\r\n\t.st13{fill:#F04B37;}\r\n\t.st14{fill:#FABE19;}\r\n\t.st15{fill:#F5871E;}\r\n\t.st16{fill:#FF6955;}\r\n\t.st17{fill:#BE281E;}\r\n\t.st18{fill:#FFDC37;}\r\n\t.st19{fill:#F58721;}\r\n\t.st20{fill:#58595B;}\r\n\t.st21{fill:#7D9BDC;}\r\n\t.st22{fill:#8C1E14;}\r\n\t.st23{fill:#9B9619;}\r\n\t.st24{fill:#DC7846;}\r\n\t.st25{fill:#646464;}\r\n\t.st26{fill:#FFE15A;}\r\n\t.st27{fill:#DC8700;}\r\n\t.st28{fill:#73821E;}\r\n\t.st29{fill:#F06423;}\r\n\t.st30{fill:#5A690A;}\r\n\t.st31{fill:#B4B928;}\r\n\t.st32{fill:#FBBE18;}\r\n\t.st33{fill:#F68820;}\r\n\t.st34{fill:#FBD301;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.284,122.627c-2.047,0-4.095-0.781-5.657-2.343L68,97.657c-1.5-1.5-2.343-3.535-2.343-5.657V80.686 c0-4.418,3.582-8,8-8s8,3.582,8,8v8l20.284,20.284c3.125,3.124,3.125,8.19,0,11.314 C100.379,121.846,98.332,122.627,96.284,122.627z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M90.628,108.971L73.657,92c-3.124-3.124-8.19-3.124-11.314,0l0,0l-8.971-8.971V63.716c0-4.418-3.582-8-8-8 s-8,3.582-8,8v22.627c0,2.122,0.843,4.157,2.343,5.657l11.314,11.313l0,0l28.284,28.284l11.314-11.314 C93.752,117.16,93.752,112.095,90.628,108.971z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M266.627,208.284h-112c-6.365,0-12.47-2.529-16.971-7.029l-58.343-58.343c-3.124-3.124-3.124-8.19,0-11.314 l22.628-22.627c3.124-3.124,8.189-3.124,11.314,0l51.314,51.314h102.059V208.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M362.627,304.284h-128v-112c0-17.673,14.327-32,32-32h96V304.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.627,
    y: 288.284,
    className: "st1",
    width: 128,
    height: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M306.627,160.284h-40c-17.673,0-32,14.327-32,32v32h8C277.974,224.284,306.627,195.631,306.627,160.284 L306.627,160.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.627,224.284v16h-12c-2.209,0-4,1.791-4,4v0c0,6.627,5.373,12,12,12h4c0,8.837,7.163,16,16,16h32v-48 H234.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M266.627,208.284h-32c-4.418,0-8,3.582-8,8s3.582,8,8,8h32v32c0,8.837,7.164,16,16,16v-48 C282.627,215.448,275.464,208.284,266.627,208.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M226.627,176.284h64c8.837,0,16-7.163,16-16v-64c0-17.673-14.327-32-32-32h-32c-17.673,0-32,14.327-32,32v64 C210.627,169.121,217.791,176.284,226.627,176.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M258.627,176.284h-32c-8.837,0-16-7.163-16-16v-64c0-17.673,14.327-32,32-32h0c17.673,0,32,14.327,32,32v64 C274.627,169.121,267.464,176.284,258.627,176.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M282.627,144.284L282.627,144.284c-4.418,0-8-3.582-8-8v-16c0-4.418,3.582-8,8-8h0c8.837,0,16,7.163,16,16v0 C298.627,137.121,291.464,144.284,282.627,144.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M362.627,160.284L362.627,160.284c-17.673,0-32,14.327-32,32v32h-48v48c0,17.673,14.327,32,32,32h48 c17.673,0,32-14.327,32-32v-80C394.627,174.611,380.301,160.284,362.627,160.284z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.627,408.284h64l0,0l0,0v-72c0-17.673-14.327-32-32-32h-240c-8.487,0-16.626,3.371-22.627,9.373l-56,56 c-6.001,6.001-9.373,14.141-9.373,22.627v16h64v0.002c0-0.001,0-0.002,0-0.002v-2.745l37.255-37.255h194.745V408.284z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.627,408.284v32c0,8.837,7.163,16,16,16h64c8.837,0,16-7.163,16-16v0c0-17.673-14.327-32-32-32H378.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.627,408.284v32c0,8.837-7.163,16-16,16h-64c-8.837,0-16-7.163-16-16v0c0-17.673,14.327-32,32-32H146.627 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.627,
    y: 368.284,
    className: "st7",
    width: 64,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.627,408.284v-16c0-8.487,3.372-16.626,9.373-22.627l16-16l45.255,45.255l-6.627,6.627v2.745H82.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.627,384.284h-80c-8.837,0-16-7.163-16-16v-32c0-17.673-14.327-32-32-32h0h176h0 c-17.673,0-32,14.327-32,32v32C346.627,377.121,339.464,384.284,330.627,384.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 314.627,
    y: 304.284,
    className: "st1",
    width: 16,
    height: 42.667
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShaolinKungFu);
export default __webpack_public_path__ + "static/media/Shaolin Kung Fu.1a54b83abc762344d45f03299364ed8b.svg";
export { ForwardRef as ReactComponent };